import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { queryDocTempAvailable, getDocumentFillByAuth, documentFillSubmit, documentFillDeleteById, saveDocumentResult, queryIsDelayDocument, getDocumentFillDataById } from '@/api/notice/documentApi.js';
import selectPerson from '@/components/select-person';
export default {
  data: function data() {
    return {
      userInfo: this.$hdk.userInfo.get(),
      personPickShow: false,
      sendForm: {
        organPostId: [],
        dodId: undefined,
        docId: undefined,
        options: undefined,
        result: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        }
      },
      newOptions: [],
      expand: false,
      form: {
        fileName: undefined,
        fileCode: undefined,
        docStatus: undefined,
        createTime: []
      },
      columns: [{
        title: '发文编号',
        dataIndex: 'fileCode',
        align: 'center',
        width: 200
      }, {
        title: '发文标题',
        dataIndex: 'fileName',
        align: 'center',
        width: 200
      }, {
        title: '密级',
        dataIndex: 'secretLevel',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'secretLevel'
        }
      }, {
        title: '拟稿日期',
        dataIndex: 'createTime',
        align: 'center',
        width: 120
      }, {
        title: '公文状态',
        dataIndex: 'docStatus',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'docStatus'
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      tableData: [],
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      paginationTable: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: this.onShowSizeChange,
        onChange: this.pageChange
      },
      templateSelect: false,
      templateList: [],
      rules: {
        options: [{
          required: true,
          message: '请输入办理结果',
          trigger: 'change'
        }]
      },
      needList: []
    };
  },
  components: {
    selectPerson: selectPerson
  },
  methods: {
    distribute: function distribute(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getDocumentFillDataById({
                id: row.id
              });
            case 1:
              res = _context.v;
              if (res.data.data.sendScope.copyDelivery.userData && res.data.data.sendScope.copyDelivery.userData.length != 0) {
                res.data.data.sendScope.copyDelivery.userData.forEach(function (element) {
                  _this.sendForm.result.userData.push({
                    id: element.userid,
                    type: element.typeid,
                    name: element.username
                  });
                });
              }
              _this.needList = [res.data.data.organId, res.data.data.postId];
              _this.sendForm.result.organId = res.data.data.organId;
              _this.sendForm.result.postId = res.data.data.postId;
              sessionStorage.setItem('needIdData', JSON.stringify({
                organId: res.data.data.organId,
                postId: res.data.data.postId
              }));
              _this.personPickShow = true;
              _this.sendForm.docId = row.id;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    handleCancel: function handleCancel() {
      this.personPickShow = false;
      this.$refs.searchFrom.resetFields();
    },
    submitSend: function submitSend() {
      var _this2 = this;
      if (this.sendForm.result.userData.length == 0) {
        this.$message.error('请选择发布范围');
        return false;
      }
      this.sendForm.result.organId = this.needList[0];
      this.sendForm.result.postId = this.needList[1];
      // return
      this.$refs.sendForm.validate(function (valid) {
        if (valid) {
          saveDocumentResult(_this2.sendForm).then(function (res) {
            if (res.data.code == 200) {
              _this2.$message.success('分发成功');
              _this2.handleCancel();
              _this2.paginationTable.current = 1;
              _this2.loadData();
            }
          });
        }
      });
    },
    loadData: function loadData() {
      var _this3 = this;
      var req = {
        fileName: this.form.fileName,
        fileCode: this.form.fileCode,
        docStatus: this.form.docStatus,
        startDate: this.form.createTime.length > 0 ? this.form.createTime[0] + ' 00:00:00' : '',
        endDate: this.form.createTime.length > 0 ? this.form.createTime[1] + ' 23:59:59' : '',
        pageSize: this.paginationTable.pageSize,
        currentNo: this.paginationTable.current
      };
      getDocumentFillByAuth(req).then(function (res) {
        if (res.data.code == 200) {
          _this3.tableData = res.data.data;
          _this3.paginationTable.total = res.data.total;
        }
      });
    },
    onShowSizeChange: function onShowSizeChange(current, pageSize) {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function pageChange(page, pageSize) {
      this.paginationTable.current = page;
      this.paginationTable.pageSize = pageSize;
      this.loadData();
    },
    handleSubmit: function handleSubmit() {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = 10;
      this.loadData();
    },
    viewTempDetail: function viewTempDetail(row) {},
    editTemp: function editTemp(row) {
      this.$router.push({
        path: '/docNotice/doc/docSendCreate',
        query: {
          mode: 'edit',
          data: row
        }
      });
    },
    createSend: function createSend() {
      this.templateSelect = true;
    },
    comfirmTemplate: function comfirmTemplate(id) {
      this.$router.push({
        path: '/docNotice/doc/docSendCreate',
        query: {
          mode: 'add',
          tempId: id
        }
      });
    },
    closeSelectTemp: function closeSelectTemp() {
      this.templateSelect = false;
    },
    viewProcessClick: function viewProcessClick(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(row));
              _context2.n = 1;
              return queryIsDelayDocument({
                docId: row.id
              });
            case 1:
              res = _context2.v;
              if (!(res.data.data === 1)) {
                _context2.n = 2;
                break;
              }
              _this4.$message.error('此公文审核未通过，无法进行查看！');
              return _context2.a(2);
            case 2:
              _this4.$router.push({
                path: '/docNotice/doc/docSendView',
                query: {
                  data: row,
                  backto: 'send'
                }
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    viewPutDetails: function viewPutDetails(row) {
      this.$router.push({
        path: '/docNotice/doc/docPutDetail',
        query: {
          id: row.id
        }
      });
    },
    getTempList: function getTempList() {
      var _this5 = this;
      queryDocTempAvailable().then(function (res) {
        if (res.data.code == 200) {
          _this5.templateList = res.data.data;
        }
      });
    },
    fillSubmit: function fillSubmit(row) {
      var _this6 = this;
      var req = {
        id: row.id,
        tempId: row.tempId,
        releaseOrganId: row.organId,
        releasePostId: row.postId
      };
      documentFillSubmit(req).then(function (res) {
        if (res.data.code == 200) {
          _this6.$message.success('提交成功');
          _this6.loadData();
        }
      });
    },
    deleteFill: function deleteFill(id) {
      var _this7 = this;
      var req = {
        id: id
      };
      documentFillDeleteById(req).then(function (res) {
        if (res.data.code == 200) {
          _this7.$message.success('删除成功');
          _this7.loadData();
        }
      });
    },
    /*
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    }
  },
  mounted: function mounted() {
    var userInfo = this.userInfo;
    this.newOptions = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
    this.getTempList();
    this.loadData();
  }
};